
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Le fait qu’il ne faut qu’une seule dose, ce qui facilite les campagnes de
vaccination, réduit le prix et permet d'obtenir plus rapidement un certificat
Covid! Et puis, il peut être conservé à une température oscillant entre 2 et 8
degrés.`}</p>
    <p>{`Ce vaccin est aussi proposé comme une alternative pour celles et ceux qui ne
veulent pas de la technique de l'ARNm. Sa distribution en Suisse est enfin une
aubaine pour les personnes qui risquent une allergie grave avec l'ARNm.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;